import {Component} from '@angular/core';
import {UserNamespace} from '@namespaces/user.namespace';

@Component({
    selector: 'app-organization-layout',
    templateUrl: './layout.component.html'
})

export class LayoutComponent {
    permissions = UserNamespace.Permission;
}
